import { ComponentsOverrides, Theme } from "@mui/material";

const inputBase = (): ComponentsOverrides<Theme>["MuiInputBase"] => ({
    root: {},
    input: {
        lineHeight: "2.2rem",
        fontSize: "16px",
    },
});

export default inputBase;
